import React, { useContext, useState } from "react";
import { FaArrowRightLong } from "react-icons/fa6";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { motion } from "framer-motion";
import linkdin from "../../assets/svgs/linkdin.svg";
import "swiper/css";
import "swiper/css/pagination";
import {
  diksha,
  vishal,
  prashant,
  ayush,
  aashtha,
  teambg,
  vaishnavi,
  shruti,
  devarshi,
  deepti,
  anshul,
  ayushi,
  candy,
  piyush,
  anjali,
  shivani,
} from "../../assets/images/index";
import { AuthContext } from "../../context/AuthContext";

type Member = {
  name: string;
  position: string;
  image: string;
  description: string;
  link: string;
};

const members: Member[] = [
  {
    name: "Diksha Kuriyal",
    position: "Founder & CEO",
    image: diksha,
    description:
      "I didn’t always know what I wanted to do as a teenager, but I knew I wasn’t going to settle. I studied B.Tech, did coding but it never really clicked for me, and eventually found my spark in sales. In 2021, I quit my job as a sales manager with no plan B - just a laptop and a gut feeling. That grit & perseverance became TechQilla. From no safety net to 2Cr+ in revenue (and counting), I’ve helped hundreds of founders and brands build a strong digital presence that actually connects. Over the years, I’ve studied the chaos, cracked the code and now I help others do it with a little more clarity and a lot less guesswork.",
    link: "https://in.linkedin.com/in/dikshakuriyal",
  },
  {
    name: "Vishal Kuriyal",
    position: "Creative Head",
    image: vishal,
    description:
      "It’s tough to write about our creative head, more so because for him everything is about the visuals. Vishal has been working for 3 years and does graphic designing, illustration, UI design, and video editing. You could describe Vishal as a gym freak, a font aficionado, and an eternal seeker of inspiration for his designs. Vishal believes in collaboration while not forgetting about his own journey.",
    link: "https://www.linkedin.com/in/vishal-kuriyal-b1a373245/",
  },
  {
    name: "Aastha Dhull",
    position: "Human Resource Manager",
    image: aashtha,
    description:
      "Dedicated HR Manager focused on hiring, training, and developing talent, with expertise in aligning people strategy with business goals to create a motivated and high-performing workforce. Experienced in driving employee engagement, fostering a positive workplace culture, and ensuring smooth HR operations. Passionate about empowering teams, optimizing processes, and contributing to organizational growth in the marketing industry.",
    link: "https://www.linkedin.com/in/aastha-dhull-53b9b424a/",
  },
  {
    name: "Prashant Semwal",
    position: "Head of Marketing",
    image: prashant,
    description:
      "From an early age, I was intrigued by virtual gaming and technology. This passion naturally progressed into a deep interest in the digital world, ultimately leading me toward specializing in digital marketing. Over the past two years, I've been focused on enhancing online visibility for businesses through SEO and PPC. As a Brand Strategist, I leverage data-driven insights to develop effective digital marketing campaigns. I enjoy combining creativity with strategic thinking to drive business growth. And yes, One Piece is real.",
    link: "https://www.linkedin.com/in/prashantsemwal1209/",
  },
  {
    name: "Ayush Semwal",
    position: "Full Stack Developer",
    image: ayush,
    description:
      "I'm a dedicated Full Stack Developer with expertise in creating efficient, user-friendly web applications. I specialize in both front-end and back-end development, leveraging modern tools and frameworks to deliver innovative solutions. I enjoy solving complex problems and continuously expanding my skills to stay ahead in the ever-evolving tech landscape.",
    link: "https://www.linkedin.com/in/ayushsemwal/",
  },
  {
    name: "Devarshi Badola",
    position: "Social Media Manager",
    image: devarshi,
    description:
      "I’m Devarshi Badola, a Content Strategist and Social Media Marketer passionate about turning ideas into impactful brand stories. With experience spanning agencies, startups, and freelance projects, I mix creativity with strategy to craft content that truly delivers. Basically, I build brands, tell stories, & convince people (including myself) that marketing isn’t just glorified scrolling",
    link: "https://www.linkedin.com/in/devarshi-badola-261779215?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
  },
  {
    name: "Shivani Bisht",
    position: "Brand Strategist",
    image: shivani,
    description:
      "I’m a Brand Strategist passionate about turning ideas into brands that people remember. At TechQilla, I work at the intersection of branding, marketing, content, and strategy — helping shape how the brand communicates, connects, and grows. I enjoy understanding people, spotting trends, creating meaningful content, and turning creative ideas into strategies that actually make an impact. Always curious. Always learning. Always building something better. ✨",
    link: "https://www.linkedin.com/in/shivani-bisht-828965232/",
  },
  {
    name: "Shruti Rai",
    position: "Graphic Designer & Video Editor",
    image: shruti,
    description:
      "With over 4 years of experience in video editing, I specialise in creating dynamic and visually engaging content for social media, corporate branding, and storytelling. I am passionate about bringing ideas to life through videos that connect with audiences and elevate brands.",
    link: "https://www.linkedin.com/in/shruti-rai-148902270/",
  },
  {
    name: "Vaishnavi",
    position: "Strategic Market Analyst",
    image: vaishnavi,
    description:
      "As a self-motivated individual, I have always been persistent and dedicated to my work, striving to give my best. Coming from a small town in India, I am deeply rooted in values. Curious to learn about anything and everything, I am always seeking new opportunities and challenges. Currently working as a Business Development Executive at TechQilla, I am focused on delivering my best performance to support the company's success while simultaneously working on my personal development",
    link: "https://www.linkedin.com/in/vaishnavi-pandey-14b120228/",
  },

  {
    name: "Ayushi",
    position: "Video Editor",
    image: ayushi,
    description:
      "A creative video editor with 2.5 years of experience, best known for crafting engaging, high-retention videos for YouTubers and digital creators. From storytelling cuts to aesthetic edits, brings energy, clarity, and style to every frame helping creators boost their content quality and audience engagement.",
    link: "https://www.linkedin.com/in/ayushi-pradhan-908144264/",
  },
  {
    name: "Anshul Chauhan",
    position: "Business Development Executive",
    image: anshul,
    description:
      "As a Business Development Executive at Techqilla, I enjoy connecting with people and helping businesses find opportunities to grow. Every client has a different story and a unique set of goals, and I find it rewarding to understand what matters most to them and help them move forward. I believe that strong relationships are built on trust, honest communication, and delivering on promises. Being part of Techqilla allows me to work with businesses across different industries, learn something new every day, and contribute to meaningful results for our clients.",
    link: "https://www.linkedin.com/in/anshul-chauhan-45aa9b201?utm_source=share_via&utm_content=profile&utm_medium=member_android",
  },
  {
    name: "Ishan Singh",
    position: "Business Development Executive",
    image: deepti,
    description:
      "Hi, I’m Ishan Singh. A graduate with a passion for learning, growth, and meaningful connections. Currently working at TechQilla, where I’m gaining experience in business development and helping businesses explore new opportunities. I believe in continuous improvement, embracing challenges, and creating value through strong relationships and innovative thinking. My goal is to keep growing professionally, contribute to impactful work, and build a career driven by purpose and progress.",
    link: "https://www.linkedin.com/in/ishan-singh-b246a02a1?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
  },
  {
    name: "Piyush Singh Karki",
    position: "UI/UX Graphic Designer",
    image: piyush,
    description:
      "I’m a UI/UX and Graphic Designer who enjoys turning ideas into meaningful digital experiences. My work is driven by a balance of creativity, strategy, and usability—whether I'm designing user-friendly interfaces, building seamless user journeys, or creating visuals that strengthen a brand's identity. I believe great design should not only look good but also solve real problems and create lasting impressions. Constantly exploring new trends, tools, and technologies, I strive to craft designs that are intuitive, impactful, and focused on the people who use them. Every project is an opportunity to learn, create, and deliver something valuable.",
    link: "https://www.linkedin.com/in/piyush-singh-47616428a/",
  },
  {
    name: "Anjali",
    position: "Business Development Executive",
    image: anjali,
    description: "I’m a client-focused professional with experience in business development, relationship management, and people-centric roles. My experience in HR and client-facing roles has helped me build strong communication, problem-solving, and relationship-building skills. At TechQilla, I work closely with businesses to understand their goals and help them with branding, digital marketing, lead generation, and technology solutions. I enjoy building genuine relationships, having meaningful conversations, and helping businesses find practical solutions that fit their vision and help them grow.",
    link: "https://www.linkedin.com/in/anjali-singh-90311336b",
  },
  {
    name: "Candy",
    position: "Chief Happiness Officer",
    image: candy,
    description:
      "Bhaw Bhaw Bhaw Bhaw Bhaw Bhaw Bhaw Bhaw Bhaw Bhaw Bhaw Bhaw Bhaw",
    link: "",
  },
];

const Creators = () => {
  const [activeMemberIndex, setActiveMemberIndex] = useState<number | null>(
    null,
  );
  const dataContext = useContext(AuthContext);
  const handleMemberClick = (index: number) => {
    const isMobile = window.innerWidth < 768; // Adjust breakpoint for mobile
    if (isMobile) {
      setActiveMemberIndex((prevIndex) => (prevIndex === index ? null : index)); // Toggle active state
    }
  };

  if (!dataContext) return null;
  const { theme } = dataContext;

  return (
    <div
      className={`${
        theme === "dark" ? "bg-white" : "bg-black"
      } flex flex-col mx-auto items-center w-full px-4 sm:px-20 justify-center py-10 sm:py-20 no-scrollbar`}
    >
      <div className="flex flex-col w-full max-w-screen-2xl">
        <div className="flex flex-col sm:flex-row justify-between sm:mr-20 gap-4 sm:gap-0">
          <motion.h2
            className={`${
              theme === "dark" ? "" : "text-white"
            } text-3xl bricolage-grotesque-bold mb-4 sm:mb-8 sm:text-5xl text-center sm:text-start`}
          >
            Meet Our Team of Creators, <br /> Designers{" "}
            <span className="text-gradient">and Problem Solvers</span>
          </motion.h2>
          <div className="flex my-auto gap-2">
            <div className="swiper-button-prev p-4 bg-secondary hover:bg-primary transition-custom rounded-full relative z-10 cursor-pointer">
              <FaArrowRightLong className="text-white rotate-180" />
            </div>
            <div className="swiper-button-next p-4 bg-secondary hover:bg-primary transition-custom rounded-full relative z-10 cursor-pointer">
              <FaArrowRightLong className="text-white" />
            </div>
          </div>
        </div>
        <div className="flex justify-center">
          <Swiper
            spaceBetween={10}
            slidesPerView={3}
            modules={[Navigation]}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 3,
              },
              1440: {
                slidesPerView: 4,
              },
            }}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            loop={true}
          >
            {members.map((member, index) => (
              <SwiperSlide key={index}>
                <div
                  className={`relative flex h-[500px] sm:h-full w-full items-end overflow-hidden rounded-2xl z-10 ${
                    activeMemberIndex === index || window.innerWidth >= 768
                      ? "group"
                      : ""
                  }`}
                  onClick={() => handleMemberClick(index)}
                >
                  {/* Background Image */}
                  <img
                    src={teambg}
                    alt="team background"
                    className={`w-full h-[85%] absolute bottom-0 transition-all duration-500 ${
                      activeMemberIndex === index
                        ? "h-full"
                        : "group-hover:h-full"
                    }`}
                  />
                  {/* Foreground Image */}
                  <img
                    className={`w-full object-cover object-top sm:object-center h-full relative z-20 transition-all duration-500 ease-in-out ${
                      activeMemberIndex === index
                        ? "opacity-0"
                        : "group-hover:opacity-0"
                    }`}
                    src={member.image}
                    alt={member.name}
                  />
                  {/* Content */}
                  <div className="custom-gradient absolute bottom-0 h-[250px] w-full z-20"></div>
                  <div className="w-full  absolute bottom-0 text-white z-30 px-5 py-4 ">
                    <div
                      className={`flex justify-between transition-all w-full duration-500 ${
                        activeMemberIndex === index
                          ? "-translate-y-8"
                          : "translate-y-[300px] sm:translate-y-[280px] lg:translate-y-[230px] xl:translate-y-[280px]  group-hover:-translate-y-8"
                      }`}
                    >
                      <h2 className="bricolage-grotesque-bold text-2xl w-full">
                        {member.name}
                      </h2>
                      <div className="size-10 flex justify-center items-center rounded-full bg-white opacity-0 group-hover:opacity-100 transition-all duration-500 cursor-pointer">
                        <a
                          href={member.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={linkdin}
                            alt="Linkdin Background"
                            className="size-5"
                          />
                        </a>
                      </div>
                    </div>
                    <p
                      className={`font-gtAmerica  font-semibold transition-all duration-500 ${
                        activeMemberIndex === index
                          ? "-translate-y-8"
                          : "translate-y-[300px] sm:translate-y-[280px] lg:translate-y-[230px] xl:translate-y-[280px]  group-hover:-translate-y-8"
                      }`}
                    >
                      {member.position}
                    </p>
                    <p
                      className={`opacity-0 transform transition-all duration-500 ease-in-out ${
                        activeMemberIndex === index
                          ? "-translate-y-8 opacity-100"
                          : "translate-y-52 group-hover:-translate-y-8 group-hover:opacity-100"
                      } text-white font-gtAmerica text-lg overflow-y-auto  h-[300px] no-scrollbar`}
                    >
                      {member.description}
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default Creators;
